<template>
    <v-dialog :value="dialog" width="800px">
        <v-card>
            <v-card-title
                    class="blue-grey darken-1 py-4 title"
            >
                Tickets selecteren
            </v-card-title>
            <template v-if="selectedTribune">
                <PriceSelection description="Kinderen" :price="selectedTribune.price_kids" v-model="total_kids"/>
                <PriceSelection description="Volwassenen" :price="selectedTribune.price_adults" v-model="total_adults"/>
                <PriceSelection description="Vriendenmatch" :price="selectedTribune.price_friendly" v-model="total_friendly"/>
                <PriceSelection description="Gratis" :price="selectedTribune.price_free" v-model="total_free"/>
            </template>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="closeDialog">Cancel</v-btn>
                <template v-if="tribuneType === 'sit'">
                    <v-btn flat dark @click="selectSeats">Plaatsen selecteren</v-btn>
                </template>
                <template v-else>
                    <v-btn flat dark @click="buyTickets">Tickets kopen</v-btn>
                </template>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { _ } from "vue-underscore";
import PriceSelection from "./PriceSelection";
export default {
  name: "TicketSelectionDialog",
  components: { PriceSelection },
  props: {
    dialog: Boolean,
    matchDates: Array,
    selectedTribune: Object,
    tribuneType: String,
    reservedSeats: Array
  },
  data() {
    return {
      total_kids: 0,
      total_adults: 0,
      total_friendly: 0,
      total_free: 0
    };
  },
  methods: {
    closeDialog: function() {
      this.$emit("closeDialog", true);
      this.resetSeatSelection();
    },
    resetSeatSelection: function() {
      this.total_kids = 0;
      this.total_adults = 0;
      this.total_friendly = 0;
      this.total_free = 0;
    },
    getNumberOfSeats: function() {
      let totalSeats = 0;
      const tickets = {
        total_kids: this.total_kids,
        total_adults: this.total_adults,
        total_friendly: this.total_friendly,
        total_free: this.total_free
      };
      Object.keys(tickets).forEach(key => {
        totalSeats = totalSeats + tickets[key];
      });

      return totalSeats > 0 ? totalSeats : 1;
    },
    buyTickets: function() {
      const selectedSeats = [];
      const allAvailableSeats = [
        ..._.range(1, this.selectedTribune.places + 1, +1)
      ];
      this.reservedSeats.forEach(seat => {
        const index = allAvailableSeats.indexOf(seat);
        if (index > -1) {
          allAvailableSeats.splice(index, 1);
        }
      });

      const numberOfSeats = this.getNumberOfSeats();
      for (let i = 0; i < numberOfSeats; i++) {
        selectedSeats.push({
          row: "/",
          seat: allAvailableSeats.shift()
        });
      }

      console.log(selectedSeats);

      this.$emit("buyTickets", {
        total_kids: this.total_kids,
        total_adults: this.total_adults,
        total_friendly: this.total_friendly,
        total_free: this.total_free,
        selectedSeats: selectedSeats
      });
      this.resetSeatSelection();
    },
    selectSeats: function() {
      this.$emit("selectSeats", {
        total_kids: this.total_kids,
        total_adults: this.total_adults,
        total_friendly: this.total_friendly,
        total_free: this.total_free
      });
      this.resetSeatSelection();
    }
  }
};
</script>
